import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { needsForcePassword } from '@app/store/selectors/session.selector';
import { GlobalState } from '@app/store/store';

@Component({
    selector: 'app-activation-steps',
    templateUrl: './activation-steps.component.html',
    styleUrls: ['./activation-steps.component.scss'],
    standalone: false
})
export class ActivationStepsComponent implements OnInit {

  needsForcePassword$: Observable<boolean | undefined>;

  constructor(private store: Store<GlobalState>) {
    this.needsForcePassword$ = this.store.select(needsForcePassword);
  }

  ngOnInit(): void {
  }

}
